module.exports = __webpack_public_path__ + "img/architecture_home.a73c9651.jpg";